import React, {Component} from 'react'
import Account from './Account'
import UserApi from '../../../api/User'
import Authentication from '../../../modules/Authentication'
import {message} from 'antd'
import {compose} from 'recompose'
import {withRouter} from 'react-router-dom'
import qs from 'qs'
import {get, pick} from 'lodash'

class AccountCont extends Component {
  constructor(props) {
    super(props)
    this.api = new UserApi()
    this.auth = new Authentication()
    const qsParsed = qs.parse(this.props.location.search.slice(1))
    this.state = {
      updating: false,
      member: this.auth.getMember(),
      expired: JSON.parse(get(qsParsed, 'expired') || 'false'),
      memberFetching: false,
    }
    this.formRef = new React.createRef()
  }

  updatePassword = async () => {
    const user = await this.checkForm()
    try {
      this.setState({updating: true})
      await this.api.update(user)
      message.success('Updated !')
      this.setState({updating: false, expired: false})
      this.formRef.current.resetFields()
    } catch (error) {
      message.error(error.errorMessage)
      this.setState({
        updating: false,
      })
    }
  }
  checkForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  render() {
    return (
      <Account
        {...this.state}
        {...pick(this, ['formRef', 'updatePassword', 'memberFetching'])}
      />
    )
  }
}

export default compose(withRouter)(AccountCont)
